/* eslint-disable @typescript-eslint/prefer-as-const */

// ported from src/web/style/_mixins.scss
// TODO: port other userful mixins over

import { CSSObj } from 'src/common/types';
import {
  BREAKPOINT_TOP_BAR_MOBILE,
  MARKETING_PAGE_BREAKPOINT_DESKTOP,
} from './breakpoints';
import { OL_COLOUR_BLACK_25, OL_COLOUR_NAVY_BABY } from './colours';

export const MIXIN_SCREEN_READER_TEXT = {
  border: 0,
  clip: 'rect(1px, 1px, 1px, 1px)',
  clipPath: 'inset(50%)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute' as 'absolute', // to get rid of typescript error
  width: '1px',
  wordWrap: 'normal' as 'normal', // to get rid of typescript error
};

export const MIXIN_SCREEN_READER_TEXT_HIDDEN_FOR_MOBILE_ONLY = {
  [`@media (min-width: ${BREAKPOINT_TOP_BAR_MOBILE}px)`]: {
    MIXIN_SCREEN_READER_TEXT,
  },
};

export const FOCUS_OUTLINE_OFFSET = -2;
export const FOCUS_OUTLINE = '1px dotted rgba(0, 0, 0, 0.55)';
export const FOCUS_BOX_SHADOW =
  '0 0 0 1px rgba(255, 255, 255, 1), 0 0 0 3px rgba(0, 0, 0, 0.55)';

export const MIXIN_FOCUS = {
  outlineOffset: FOCUS_OUTLINE_OFFSET,
  outline: FOCUS_OUTLINE,
  boxShadow: FOCUS_BOX_SHADOW,
};

export const MIXIN_ANCHOR_BUTTON = {
  display: 'inline-block',
  padding: 0,
  margin: 0,
  border: 'none',
  background: 'none',
  verticalAlign: 'baseline',
  cursor: 'pointer',
  fontFamily: 'inherit', // override bootstrap
  fontSize: 'inherit', // override bootstrap
  fontWeight: 600,
  color: OL_COLOUR_NAVY_BABY,
  textDecoration: 'underline',

  '&:disabled': {
    color: OL_COLOUR_BLACK_25,
    cursor: 'default',
  },
};

export const MIXIN_IMAGE_FILL_FRAME = {
  position: 'relative',
  overflow: 'hidden',
};

interface mixinImageFillFrameResponsiveProps {
  width?: number;
  height?: number;
}

export const mixinImageFillFrameResponsive = ({
  width = 3,
  height = 4,
}: mixinImageFillFrameResponsiveProps): CSSObj => ({
  // this somehow generate type error, so copied and pasted attributes instead for now
  // ...MIXIN_IMAGE_FILL_FRAME,
  position: 'relative',
  overflow: 'hidden',

  height: 0,
  paddingTop: `${(height / width) * 100}%`,
  paddingRight: 0,
  paddingBottom: 0,
  paddingLeft: 0,
});

export const MIXIN_IMAGE_FILL_IMG: CSSObj = {
  position: 'absolute',
  display: 'block',
  margin: 'auto',

  /*
  To remove any 100% max-width/max-height set by css frameworks
  like bootstrap
  */
  maxWidth: '1000%',
  maxHeight: '1000%',

  /*
  -100% so image can be stretched more than 100% and still be centered.
  */
  top: '-100%',
  bottom: '-100%',
  left: '-100%',
  right: '-100%',
};

export const IMAGE_FILL_IMG_FIT_WIDTH = {
  ...MIXIN_IMAGE_FILL_IMG,

  height: 'auto',
  width: '100%',
};

export const IMAGE_FILL_IMG_FIT_HEIGHT = {
  ...MIXIN_IMAGE_FILL_IMG,

  width: 'auto',
  height: '100%',
};

export const MIXIN_COURSE_CARD_GRID: CSSObj = {
  display: 'flex',
  flexWrap: 'wrap',
  flexDirection: 'row',
  justifyContent: 'flex-start',
};

export const MIXIN_COURSE_CARD_GRID_TILE = {
  width: '100%',
  marginBottom: '4%',

  [`@media only screen and (min-width: 600px)`]: {
    width: '48%',
    marginBottom: '4%',

    '&:nth-of-type(n)': {
      marginRight: '4%',
    },

    '&:nth-of-type(2n)': {
      marginRight: 0,
    },
  },

  [`@media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP})`]: {
    width: '31%',
    marginBottom: '3.5%',

    '&:nth-of-type(n)': {
      marginRight: '3.5%',
    },

    '&:nth-of-type(3n)': {
      marginRight: 0,
    },
  },
};
